import React from "react";

export default ({ record, prefix = "", source }) => (
	<span>
		{prefix}
		{record[source]}
	</span>
);
